/**
 * Csv Schema of ResponsavelVisualizador
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {ResponsavelVisualizador} from '@/model/resource/ResponsavelVisualizador'

/* TODO: review generated schema */
export class CsvResponsavelVisualizadorSchema extends Schema {
  readonly name = 'CsvResponsavelVisualizador'

  readonly fieldSet: FieldSet<ResponsavelVisualizador> = {
    idVisualizadorPk: schema => schema.model.idVisualizadorPk,
    responsavel: schema => schema.model.responsavel?.$id ?? null,
    nome: schema => schema.model.nome,
    email: schema => schema.model.email,
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
